

import __layout_0 from '/app/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/app/src/layouts/blank.vue'),
'default': __layout_0,
'components/DefaultLayoutWithHorizontalNav': () => import('/app/src/layouts/components/DefaultLayoutWithHorizontalNav.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/app/src/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/app/src/layouts/components/Footer.vue'),
'components/NavBarNotifications': () => import('/app/src/layouts/components/NavBarNotifications.vue'),
'components/NavSearchBar': () => import('/app/src/layouts/components/NavSearchBar.vue'),
'components/NavbarShortcuts': () => import('/app/src/layouts/components/NavbarShortcuts.vue'),
'components/NavbarThemeSwitcher': () => import('/app/src/layouts/components/NavbarThemeSwitcher.vue'),
'components/UserProfile': () => import('/app/src/layouts/components/UserProfile.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
